
import React from "react";
import { Badge } from "./ui/badge";

interface SubscriptionTierBadgeProps {
  tier: "free" | "standard" | "premium" | "ultimate";
  className?: string;
}

export const SubscriptionTierBadge = ({ tier, className }: SubscriptionTierBadgeProps) => {
  const getTierConfig = (tier: string) => {
    switch (tier) {
      case "free":
        return {
          label: "Free",
          variant: "secondary" as const,
          className: "bg-gray-100 text-gray-800 hover:bg-gray-100"
        };
      case "standard":
        return {
          label: "Standard",
          variant: "default" as const,
          className: "bg-blue-100 text-blue-800 hover:bg-blue-100"
        };
      case "premium":
        return {
          label: "Premium",
          variant: "default" as const,
          className: "bg-purple-100 text-purple-800 hover:bg-purple-100"
        };
      case "ultimate":
        return {
          label: "Ultimate",
          variant: "default" as const,
          className: "bg-gradient-to-r from-yellow-400 to-orange-500 text-white hover:from-yellow-500 hover:to-orange-600"
        };
      default:
        return {
          label: "Unknown",
          variant: "outline" as const,
          className: "bg-gray-100 text-gray-600 hover:bg-gray-100"
        };
    }
  };

  const config = getTierConfig(tier);

  return (
    <Badge 
      variant={config.variant} 
      className={`${config.className} ${className || ""}`}
    >
      {config.label}
    </Badge>
  );
};
